export * from './vertical_dots_icon';
